import { useEffect } from "react";

export default function RedirectDraaikiepraam() {
  useEffect(() => {
    const basePath = (window as any).__BASE_PATH__ || "";
    const prefix = basePath ? `/${basePath}` : "";
    window.location.replace(`${prefix}/draaikiepraam-reparatie/`);
  }, []);

  return (
    <main className="bg-white min-h-screen flex items-center justify-center">
      <title>Draaikiepraam reparatie Eindhoven | 48u Service</title>
      <meta name="description" content="Draaikiepraam niet meer sluiten of klem ? Wij repareren en stellen draaikiepramen af in Eindhoven. 48u-spoedservice, vaste prijs vanaf €75, 10 jaar garantie." />
      <meta httpEquiv="refresh" content="0;url=/draaikiepraam-reparatie/" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/draaikiepraam-reparatie/" />
      <div className="text-center px-4">
        <p className="font-geist text-base text-brand-text/70 mb-3">
          Deze pagina is verplaatst naar{" "}
          <a href="/draaikiepraam-reparatie/" className="text-brand-blue underline">
            draaikiepraam-reparatie
          </a>
          .
        </p>
        <p className="font-geist text-sm text-brand-text/50">
          U wordt automatisch doorgestuurd...
        </p>
      </div>
    </main>
  );
}